import { APITransport } from '@client/transports/api';

export const VirtualBackgroundService = {
  delete(body) {
    return APITransport.post({
      path: '/rest/domain/delete/brandkits',
      body
    });
  },

  async getAll() {
    const response = await APITransport.get({
      path: '/rest/domain/brandkits'
    });

    return Array.isArray(response) ? response : [];
  },

  async getById(id) {
    const backgrounds = await this.getAll();

    return backgrounds.find(({ rulename }) => rulename === id);
  },

  update(body) {
    return APITransport.post({
      path: '/rest/domain/save/brandkits',
      body
    });
  },

  async getFields(query) {
    const userParams = await APITransport.get({
      path: '/rest/listofvalues/listuserparams',
      query
    });

    const params = Array.isArray(userParams) ? userParams : [];

    return [...new Set(params.map((param) => param.name))].sort();
  }
};
